<template>
  <div class="nav-wrap">
    <div class="meta-wrap">
      <PromoLogo class="logo" />

      <router-link to="/" class="meta-link"> Home</router-link>
    </div>

    <div class="block md:hidden self-center px-3">
      <button
        class="sidebar-toggle"
        :class="{ active: mobileSidebar }"
        @click="$emit('mobile-nav', 'mobileSidebar')"
      >
        <v-icon slot="icon-end" name="bars" />
      </button>
    </div>

    <nav class="nav">
      <media :query="{ minWidth: screens.md }">
        <SupportNav
          class="ml-auto mr-1"
          :show-feedback="false"
          :show-updates="false"
        />
      </media>

      <SendControls
        :sending-test="sendingTest"
        :loading="loading"
        :account-id="accountId"
        class="ml-auto md:ml-0"
        @test-send="$emit('test-send')"
      />
    </nav>
  </div>
</template>

<script>
import Media from "vue-media";
import PromoLogo from "@/components/UI/PromoLogo";
import SendControls from "@/components/Editor/SendControls";
import SupportNav from "@/components/Editor/SupportNav";

export default {
  name: "Header",
  inject: ["screens"],
  components: { Media, PromoLogo, SendControls, SupportNav },
  props: {
    accountId: { default: "", type: String },
    loading: { default: false, type: Boolean },
    mobileSidebar: { default: false, type: Boolean },
    sendingTest: { default: false, type: Boolean },
  },
  methods: {
    onApproveSend() {
      this.$gtm.trackEvent({
        event: "promo-approve-send",
        accountId: this.accountId,
      });
    },
  },
};
</script>

<style scoped>
.nav-wrap {
  @apply flex flex-wrap bg-support fixed w-full;
  z-index: 2;
}

.nav {
  @apply flex items-center justify-between flex-wrap flex-1 pl-0 pr-4 py-6;

  @screen sm {
    @apply p-6;
  }
}

.logo {
  max-width: 110px;

  @screen sm {
    max-width: 150px;
  }
}

.meta-wrap {
  @apply flex flex-col justify-center items-center flex-no-shrink px-4;
  background: #34414c;
  border-right: 1px solid #152935;

  @screen sm {
    @apply px-6;
  }
}

.meta-icon {
  @apply relative text-grey-dark;
  top: 3px;
}

.meta-link {
  @apply text-grey-dark no-underline text-xs mt-1;

  &:hover {
    @apply no-underline text-brand-lighter;

    .meta-icon {
      @apply text-brand-lighter;
    }
  }
}

.sidebar-toggle {
  @apply flex items-center px-3 py-2 text-white outline-none;
  transition: transform 150ms ease-in;

  &:hover,
  &.active {
    @apply text-brand-alt;
  }

  &.active {
    transform: rotate(90deg);
  }

  &:focus {
    @apply outline-none;
  }
}
</style>
